import ProductSelect from '../ProductSelect.vue'
import {
  required
} from 'vuelidate/lib/validators'
import requiredOneOfTwo from '../../../validators/requiredOneOfTwo'
import ProductList from './ProductList.vue'
import greaterOrEqualTo from "../../../validators/greaterOrEqualTo";

export default {
  name: 'BuyXGetYOff',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data () {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        rewardsSubsidy: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          rewardMoneyEarnedPerRedemption: null,
          redemptionLimit: null,
          salesRedemptionLimit: null,
          sumOff: null,
          percentageOff: null
        }
      },
      purchasedProductSelectShown: false
    }
  },

  computed: {
    // TODO: Duplicate
    name () {
      // TOOD: make some text adjustments
      let name = 'Buy '
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X'
      name += ' and get '
      if (this.promotion.rewards.sumOff) {
        name += '$' + this.promotion.rewards.sumOff
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '%'
      } else {
        // name += 'free or reduced price'
      }

      name += ' off'

      return name
    },

    nameLat () {
      return this.name
    },
    discountedPriceFormula () {
      return (basePrice) => {
        if (this.promotion.rewards.sumOff) {
          return basePrice - this.promotion.rewards.sumOff
        } else if (this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * this.promotion.rewards.percentageOff / 100
        } else {
          return basePrice
        }
      }
    },

    customerMustBuyError () {
      return this.$v.promotion.requirements.purchasedAmount.$error || this.$v.promotion.requirements.purchasedProducts.$error
    },

    customerWillGetError () {
      return this.$v.promotion.rewards.sumOff.$error ||
        this.$v.promotion.rewards.percentageOff.$error
    },

    disablePercentageOff () {
      return (this.promotion.type !== 'MULTIBUY_GET_PERCENTAGE_OFF' && typeof this.promotion.type !== 'undefined')
    },

    disableSumOff () {
      return (this.promotion.type !== 'MULTIBUY_GET_SUM_OFF' && typeof this.promotion.type !== 'undefined')
    }
  },

  validations: {
    promotion: {
      targetMargin: {
        required
      },
      rewardsSubsidy: {
        required
      },
      requirements: {
        purchasedProducts: {
          required
        },
        purchasedAmount: {
          required
        }
      },
      rewards: {
        redemptionLimit: {
          greater: greaterOrEqualTo('promotion.rewards.awardedAmount')
        },
        sumOff: {
          required: requiredOneOfTwo('promotion.rewards.percentageOff')
        },
        percentageOff: {
          required: requiredOneOfTwo('promotion.rewards.sumOff')
        }
      }
    }
  },

  components: {
    'product-select': ProductSelect,
    'product-list': ProductList
  },

  methods: {

    addPurchasedProduct (product) {
      product.id = product.productID
      product.plu = product.code
      this.promotion.requirements.purchasedProducts.push(product)
    },

    hide (event) {
      if (this.purchasedProductSelectShown || this.awardedProductSelectShown) {
        event.preventDefault()
      } else {
        this.$emit('hide')
      }
    },

    removeAwardedProduct (item) {
      this.promotion.rewards.awardedProducts = this.promotion.rewards.awardedProducts.filter(product => {
        if (item !== product) {
          return product
        }
      })
    },

    removePurchasedProduct (item) {
      this.promotion.requirements.purchasedProducts = this.promotion.requirements.purchasedProducts.filter(product => {
        if (item !== product) {
          return product
        }
      })
    },

    reset () {
      this.tab = 0
      this.$v.$reset()
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId
        this.promotion.targetMargin = this.value.targetMargin
        this.promotion.rewardsSubsidy = this.value.rewardsSubsidy
        this.promotion.oncePerDay = this.value.oncePerDay
        this.promotion.customerGroupId = this.value.customerGroupId
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts
        this.promotion.rewards.rewardMoneyEarnedPerRedemption = this.value.rewards.rewardMoneyEarnedPerRedemption ? this.value.rewards.rewardMoneyEarnedPerRedemption : 0
        this.promotion.rewards.sumOff = this.value.rewards.sumOff
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff
        this.promotion.type = this.value.type
        this.promotion.rewards.redemptionLimit = this.value.rewards.redemptionLimit
        this.promotion.rewards.salesRedemptionLimit = this.value.rewards.salesRedemptionLimit
      } else {
        this.promotion = {
          customerGroupId: 0,
          targetMargin: null,
          rewardsSubsidy: null,
          page: null,
          oncePerDay: null,
          positionOnPage: null,
          requirements: {
            purchasedProducts: [],
            purchasedAmount: null
          },
          rewards: {
            rewardMoneyEarnedPerRedemption: null,
            redemptionLimit: null,
            salesRedemptionLimit: null,
            sumOff: null,
            percentageOff: null
          }
        }
      }
    },

    savePromotion () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.promotion.hasBeenEdited = true
      this.promotion.name = this.name
      this.promotion.nameLat = this.nameLat
      this.$emit('change', this.promotion)
      this.hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/EditEvent/AddPromotion/BuyXGetYOff.js